import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AssignmentScheduleStateService } from '../../services/assignment-schedule-state.service';

@Component({
    selector: 'app-assignment-schedule-answer-filter-display',
    templateUrl: './assignment-schedule-answer-filter-display.component.html',
    styleUrl: './assignment-schedule-answer-filter-display.component.scss'
})
export class AssignmentScheduleAnswerDisplayComponent implements OnInit, OnDestroy {

    private filterModelSubjectChanged?: Subscription;

    constructor(
        protected assignmentScheduleStateService: AssignmentScheduleStateService,
    ) { }

    ngOnDestroy(): void {
        if (this.filterModelSubjectChanged) this.filterModelSubjectChanged.unsubscribe();
    }

    ngOnInit(): void {
        this.subscribeToFilterModelChanges();
    }

    public resetFilterDisplayItems(): void {
        this.assignmentScheduleStateService.resetAllItems();
        this.resetFilterModel();
    }

    protected resetFilterModel(): void {
        // const defaultFilterModel = this.assignmentStateService.setAssignmentFilterDefault();
        // this.filterModelSubject?.next(defaultFilterModel);
    }


    private subscribeToFilterModelChanges(): void {
        this.filterModelSubjectChanged = this.assignmentScheduleStateService.assignmentSchedulesFilterSubject?.subscribe((filterModel) => {
            this.assignmentScheduleStateService.updateFilterDisplay(filterModel);
            this.assignmentScheduleStateService.updateIsAnyFilterDisplayed();
        });
    }
}
